import { useEffect } from 'react';

const useOnlimZIndexObserver = () => {
  useEffect(() => {
    function setOnlimZIndex(hide) {
      const chatPreview = document.getElementById('onlim-chat-widget-preview');
      const floatingButton = document.getElementById('helpFloatingButton');

      if (!chatPreview) {
        requestAnimationFrame(setOnlimZIndex);
      } else if (hide) {
        chatPreview.style.cssText += ' z-index: 999 !important;';
        floatingButton.style.cssText = 'z-index: 0;';
      } else {
        chatPreview.style.cssText = chatPreview.style.cssText.replace(
          ' z-index: 999 !important;',
          '',
        );

        // Wait for the burger close animation to finish
        setTimeout(() => {
          floatingButton.style.cssText = '';
        }, 400);
      }
    }

    const handleMutation = mutationsList => {
      mutationsList.forEach(mutation => {
        if (
          mutation.type === 'attributes' &&
          mutation.attributeName === 'style'
        ) {
          const currentStyle = mutation.target.style.cssText;
          if (currentStyle.includes('overflow: hidden;')) {
            setOnlimZIndex(true);
          } else {
            setOnlimZIndex(false);
          }
        }
      });
    };

    const handlePageLoad = () => {
      const bodyObserver = new MutationObserver(handleMutation);

      bodyObserver.observe(document.querySelector('body'), {
        attributes: true,
        attributeFilter: ['style'],
      });
    };

    window.addEventListener('load', handlePageLoad);

    return () => {
      window.removeEventListener('load', handlePageLoad);
    };
  }, []);
};

export default useOnlimZIndexObserver;
